var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadModsawdown = function SvgFadModsawdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.032 208c2.208 0 2.618-1.144.925-2.546L37.105 51.546c-1.698-1.406-3.074-.76-3.074 1.464v150.98a4.003 4.003 0 0 0 3.996 4.01h8.008a3.996 3.996 0 0 0 3.996-4.007V84.007c0-2.213 1.387-2.861 3.079-1.465l148.842 122.916c1.7 1.404 4.87 2.542 7.078 2.542h13.002z",
    fillRule: "evenodd"
  })));
};
export { SvgFadModsawdown as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-modsawdown.1ac62829.svg";